import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { ApplicationHttpService } from "../../../core/services/application-http.service";
import { Assessment } from "../models/assessment.model";
import { ErrorRegister } from "../models/error-register.model";
import { History, HistoryResponse } from "../../../shared/models/history.model";
import { MojResult } from "../models/moj-result.model";
import { ApplicationVersion } from "../models/application-version.model";
import { PostRegSubjectRef } from "../../../shared/models/post-reg-subject.model";

/**
 * api-int scopes status-history and feed to a person only when it gets the event id, the subject
 * type and the subject id together (400 otherwise), so the pair is appended as one unit.
 */
export function subjectQuery(subject?: PostRegSubjectRef | null): string {
    return subject ? `&subjectType=${subject.subjectType}&subjectId=${subject.subjectId}` : '';
}

/** History, versions, assessments, error register and MoJ results for an application. */
@Injectable()
export class ApplicationHistoryService {

    constructor(private http: ApplicationHttpService) {
    }

    getAllHistoryVersions(applicationId: string): Observable<ApplicationVersion[]> {
        return this.http
            .get<any>(`back-office-application/${applicationId}/all-versions-info`)
            .pipe(
                map((response) => response.info ?? [])
            );
    }

    getHistory(applicationId: string, pageNumber: number, pageSize: number): Observable<HistoryResponse> {
        return this.http.get<HistoryResponse>(`back-office-application/status-history/all-version/${applicationId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
    }

    getActualHistory(id: number): Observable<History[]> {
        return this.http.get<History[]>(`back-office-application/status-history/${id}`);
    }

    getAssessment(id: number): Observable<Assessment[]> {
        return this.http.get<Assessment[]>(`back-office-document/${id}`);
    }

    getErrorRegister(applicationId: string): Observable<ErrorRegister[]> {
        return this.http.get<ErrorRegister[]>(`error-register/all-version/${applicationId}`);
    }

    mojResult(applicationId: string): Observable<MojResult[]> {
        return this.http.get<MojResult[]>(`moj-result/all-version/${applicationId}`);
    }


    /** With `subject`, only that person's rows; without it, the event's own rows (api-int excludes subject rows). */
    getActualHistoryByEvent(backOfficeApplicationId: number, postRegEventId: number, subject?: PostRegSubjectRef | null): Observable<History[]> {
        return this.http.get<History[]>(`back-office-application/status-history/${backOfficeApplicationId}?backOfficePostRegEventId=${postRegEventId}${subjectQuery(subject)}`);
    }

    getErrorRegisterByEvent(backOfficeApplicationId: number, postRegEventId: number): Observable<ErrorRegister[]> {
        return this.http.get<ErrorRegister[]>(`error-register/list/${backOfficeApplicationId}?backOfficePostRegEventId=${postRegEventId}`);
    }

    mojResultByEvent(backOfficeApplicationId: number, postRegEventId: number): Observable<MojResult[]> {
        return this.http.get<MojResult[]>(`moj-result/${backOfficeApplicationId}?backOfficePostRegEventId=${postRegEventId}`);
    }
}
